import React, { useState } from 'react';

import { DatadogSessionReplayMask } from 'features/observability/rum/datadog-session-replay-mask';

import { TextInputMask } from 'components/ucl';
import { primitive } from 'styles/constants';
import { isNative } from 'utils/environment';
import { getCursorPosition, loyaltyCrownCardNumberMask } from 'utils/masks';
import noop from 'utils/noop';

type AddGiftCardInputProps = {
  label?: string;
  initialValue?: string;
  onChange?: (value: string) => void;
  errorMessage?: string;
  onFocus?: () => void;
  testID?: string;
  isRedesign?: boolean;
  isLoading?: boolean;
};

function AddGiftCardInput({
  initialValue = '',
  label = '',
  onChange = noop,
  onFocus = noop,
  errorMessage = '',
  testID: dataTestId,
  isRedesign = false,
  isLoading = false,
}: AddGiftCardInputProps) {
  const [value, setValue] = useState(initialValue);
  const [isFocused, setIsFocused] = useState(false);

  const [cursorPosition, setCursorPosition] = useState(0);
  const [isBackspaceKey, setIsBackspaceKey] = useState(false);

  const handleChangeText = (changedValue: string) => {
    if (isRedesign && !isNative) {
      // Adjusting Cursor position
      setCursorPosition(prevPosition => getCursorPosition(isBackspaceKey, prevPosition));
    }
    setValue(changedValue);
    onChange(changedValue);
  };

  const handleKeyPress = (event: any) => {
    const key = event.nativeEvent.key;

    if (key === 'Backspace') {
      setIsBackspaceKey(true);
    } else {
      setIsBackspaceKey(false);
    }
  };

  return (
    <DatadogSessionReplayMask>
      <TextInputMask
        accessibilityLabel={label || undefined}
        label={label}
        value={value}
        onChangeText={handleChangeText}
        errorMessage={errorMessage}
        onFocus={() => {
          setIsFocused(true);
          onFocus();
        }}
        onBlur={() => {
          setIsFocused(false);
        }}
        placeholderTextColor={primitive.$blackOpacity50}
        required
        placeholder=""
        {...(isRedesign && !isFocused && { placeholder: '0000 0000 0000 0000' })}
        {...(isRedesign &&
          !isNative && {
            onSelectionChange: event => {
              const { selection } = event.nativeEvent;
              setCursorPosition(selection.start);
            },
            onKeyPress: handleKeyPress,
            selection: { start: cursorPosition, end: cursorPosition },
          })}
        testID={dataTestId}
        keyboardType="numeric"
        returnKeyType="done"
        mask={loyaltyCrownCardNumberMask}
        isDisabled={isLoading}
      />
    </DatadogSessionReplayMask>
  );
}

export default AddGiftCardInput;
